export default __webpack_public_path__ + "static/media/add.a03169fc.svg";